<template>
  <div class="row task-container">
    <div class="col-md-12">
      <table class="table table-striped task-table" :id="tableId">
        <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Comment</th>
          <th>Emoji</th>
          <th>Created At</th>
          <th v-if="tab === 'resolved'">Resolved By</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row,index) in list" :key="index">
          <td>{{row.fullName}}</td>
          <td>{{row.email}}</td>
          <td>{{row.comment.length >15 ? `${row.comment.substring(0, 15)}...` : row.comment}}</td>
          <td>
            <vue-reaction-emoji v-if="row.emojiReaction" height="30px" width="30px" :is-active="true" :reaction="row.emojiReaction" />
          </td>
          <td>{{row.createdAt | formatDate}}</td>
          <td  v-if="tab === 'resolved'">{{ row.resolvedBy || '' }}</td>
          <td>
            <button @click="openModal(row)" title="View Details" class="btn btn-primary btn-sm ml-2">
              <i class="fa fa-eye"></i>
            </button>
            <button v-if="tableId === 'activeFeedback'" @click="resolveButton(row, index)" :loading="selectedIndex === index" :disabled="selectedIndex === index" class="btn btn-primary btn-sm ml-2">
              Resolve
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { VueReactionEmoji } from 'vue-feedback-reaction';
export default {
  name: "index",
  components: {
    VueReactionEmoji
  },
  props: {
    tableId: {
      type: String
    },
    list: {
      type: Array
    },
    tab: {
      type: String,
      required: false,
      default: 'pending'
    }
  },
  data () {
    return {
      selectedIndex: null
    }
  },
  methods: {
    async resolveButton (row, index) {
      try {
        this.selectedIndex = index
        this.$emit('resolve', {...row})
      } catch (e) {
        console.log()
      } finally{
        this.selectedIndex = null
      }
    },
    openModal (data) {
      this.$emit('openDetailModal', data)
    }
  }
}
</script>

<style scoped>

</style>